
export { createAnalytics } from "./browser/createAnalytics.es.js"
export { i as plugins } from "./index-12a28e88.js"